import { render, staticRenderFns } from "./Menu.vue?vue&type=template&id=7422d4f4"
import script from "./Menu.vue?vue&type=script&lang=js"
export * from "./Menu.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/AzDevOps/myagent/_work/11/s/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7422d4f4')) {
      api.createRecord('7422d4f4', component.options)
    } else {
      api.reload('7422d4f4', component.options)
    }
    module.hot.accept("./Menu.vue?vue&type=template&id=7422d4f4", function () {
      api.rerender('7422d4f4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/layout/quick/Menu.vue"
export default component.exports